<template>
  <div>
    <a-tabs
      default-active-key="department"
      @change="
        (key) => {
          keyChange = key;
        }
      "
    >
      <a-tab-pane key="department" tab="Department">
        <SelectDepartment
          v-model="departmentIds"
          :select-props="{
            placeholder: 'Select department',
            value: departmentIds,
            mode: 'multiple',
            style: 'width: 100%;',
          }"
          @change="
            () => {
              if (departmentIds.length > 0) {
                onGetUsers({
                  queryValue: '',
                  callback: (users) => {
                    userFromDepartments = [...users];
                  },
                });
              } else {
                userFromDepartments = [];
              }
            }
          "
        />
        <a-list
          item-layout="horizontal"
          :data-source="userFromDepartments"
          style="margin-top: 10px; max-height: 500px; overflow-y: auto;"
        >
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            style="margin-top: 20px;"
          >
            <a-list-item-meta>
              <a slot="title">
                {{ item.email }}
                <br />
                {{ item.fullname }}
              </a>
            </a-list-item-meta>
            <a-button
              type="link"
              slot="actions"
              style="border: 0;"
              icon="close"
              @click="onRemoveUserId(item.id)"
            ></a-button>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="account" tab="Account">
        <a-select
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          show-search
          mode="multiple"
          style="width: 100%;"
          placeholder="Search account"
          v-model="userIds"
          @search="(value) => onGetUsers({ queryValue: value })"
          :loading="loadingUser"
        >
          <a-select-option v-for="i in users" :key="i.id">
            {{ i.fullname || i.username }}
            -
            {{ i.email }}
          </a-select-option>
        </a-select>
      </a-tab-pane>
    </a-tabs>

    <div style="text-align: right; margin-top: 10px;">
      <a-button style="margin-right: 10px;" @click="close">Close</a-button>
      <a-button
        :disabled="disabledAdd"
        type="primary"
        icon="plus"
        :loading="loadingBtn"
        @click="() => addExceptUser(keyChange)"
      >
        Set Permission
      </a-button>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import query from "../../../../constants/query";
import SelectDepartment from "@/components/common/department/select";

export default {
  components: { SelectDepartment },
  props: {
    close: {
      type: Function,
      required: true,
    },
    refreshAfterAdd: {
      type: Function,
      required: true,
    },
    idAppConfig: {
      type: String,
      required: true,
    },
  },
  data() {
    this.onGetUsers = debounce(this.onGetUsers, 500);

    return {
      userIds: [],
      users: [],
      departmentIds: [],
      userFromDepartments: [],
      loadingBtn: false,
      loadingUser: false,
      disabledAdd: true,
      keyChange: "department",
    };
  },
  computed: {
    departmentOrUser() {
      return `${this.userFromDepartments}|${this.userIds}|${this.keyChange}`;
    },
  },
  watch: {
    departmentOrUser() {
      this.disabledAdd =
        this.keyChange === "department"
          ? this.userFromDepartments.length === 0
          : this.userIds.length === 0;
    },
  },
  methods: {
    onGetUsers({ queryValue, callback }) {
      this.loadingUser = true;
      this.$apollo
        .query({
          query: query.users,
          variables: {
            query: queryValue,
            departmentIds: this.departmentIds,
          },
        })
        .then(({ data }) => {
          if (data?.users) {
            this.users = [...data.users];
            if (callback && typeof callback == "function") {
              callback(data.users);
            }
          }

          this.loadingUser = false;
        })
        .catch((err) => {
          this.loadingUser = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy danh sách tài khoản không thành công!",
          });
          console.log("Lấy danh sách tài khoản không thành công!", err);
        });
    },
    addExceptUser(flag) {
      this.loadingBtn = true;
      if (this.disabledAdd) {
        return false;
      }
      if (!this.idAppConfig) {
        throw new Error("cannot get id app platform");
      }
      this.$apollo
        .mutate({
          mutation: query.addExcludeUsersToAppInPlatform,
          variables: {
            userIds:
              flag === "department"
                ? this.userFromDepartments.map((e) => e.id)
                : this.userIds,
            id: this.idAppConfig,
          },
        })
        .then(({ data }) => {
          if (
            data?.addExcludeUsersToAppInPlatform?.userCanAccess?.length >= 0
          ) {
            this.refreshAfterAdd(
              data.addExcludeUsersToAppInPlatform.userCanAccess
            );
          }
          this.userIds = [];
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Update success!",
          });
          this.close();
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Update error!",
          });
          console.error("Cập nhật tài khoản lỗi!", error);
        });
    },
    onRemoveUserId(userId) {
      const index = this.userFromDepartments.findIndex((e) => e.id === userId);
      if (index >= 0) {
        this.userFromDepartments.splice(index, 1);
      }
    },
  },
};
</script>
<style lang="css" scoped></style>
